export default function CorrectIcon() {
  return (
    <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
      <svg
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.4">
          <path
            d="M19.5 35.75C10.5403 35.75 3.25291 28.4583 3.25291 19.5C3.25291 10.5373 10.5403 3.25 19.5 3.25C28.4597 3.25 35.7471 10.5417 35.7471 19.5C35.7471 28.4627 28.4597 35.75 19.5 35.75ZM19.5 0C8.74575 0 0 8.74832 0 19.5C0 30.2517 8.74575 39 19.5 39C30.2499 39 39 30.2517 39 19.5C38.9956 8.74832 30.2499 0 19.5 0Z"
            fill="white"
          />
          <path
            d="M25.1148 15.1673L17.1541 23.8545L13.8976 20.21C13.2797 19.5199 12.2198 19.4613 11.5297 20.0747C10.8396 20.6927 10.7765 21.7526 11.3944 22.4427L15.8912 27.4719C16.2069 27.8238 16.6579 28.0267 17.1315 28.0312H17.1405C17.6096 28.0312 18.0607 27.8328 18.3809 27.4855L27.5909 17.4316C28.2179 16.7505 28.1683 15.6905 27.4872 15.0635C26.8016 14.4411 25.7417 14.4862 25.1148 15.1673Z"
            fill="white"
          />
        </g>
      </svg>
    </div>
  );
}
